import { apiCall } from '../apiServerHelper'
import { apis } from '../apiUrls'

export const hitTypes = {
  OFFMARKET_VIEW: 'offmarket_view',
  OFFMARKET_VIEW_NOLOGIN: 'offmarket_view_nologin'
}

export const logHit = async ({ id = null, type = '' }) => {
  if (!id || !type) return false
  const url = `${apis.LOG_HIT}${id}/${type}/`
  return await apiCall(url, false, 'post')
}
